var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Footer from "../../App/Footer";
import MarkdownViewer from "../../Markdown";
import { Context } from "../../Markdown/components";
import { ErrorBoundary } from "../../App/ErrorHandling/ErrorBoundary";
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { ErrorFallback } from "../../App/ErrorHandling/ErrorFallback";
import { parseRenderingError } from "../../App/ErrorHandling/ErrorUtils";
import { NeedAuthorization } from "../../Auth";
import Script from "./Script";

const parseSSRError = (error) => {
  const SSRError = error instanceof Immutable.Map ? error.toJS() : error;
  return SSRError !== null && SSRError !== void 0 && SSRError.json ? parseRenderingError(SSRError) : null;
};

class PageViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.warningPageError = this.warningPageError.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.page.get('title') !== this.props.page.get('title')) {
      this.removeCustomPageError();
    }
  }

  componentWillUnmount() {
    if (this.state.customPageError) {
      this.removeCustomPageError();
    }
  }

  warningPageError(error) {
    this.setState({ customPageError: error });
  }

  removeCustomPageError() {
    this.setState({ customPageError: null });
  }

  renderErrorWarning() {
    return /*#__PURE__*/(
      _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
      _jsx("div", { className: "alert alert-danger" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), /*#__PURE__*/
      _jsx(Translate, { translationKey: "custom page error warning" }, void 0, "There is an unexpected error on this custom page, it may not work properly. Please contact an admin for details."


      ), /*#__PURE__*/
      _jsx(Icon, { icon: "times", onClick: () => this.removeCustomPageError() })
      )
      ));

  }

  render() {
    const { page, itemLists, datasets, error, setBrowserTitle } = this.props;
    const lists = itemLists.toJS();
    const originalText = page.getIn(['metadata', 'content']) || '';
    const scriptRendered = page.getIn(['scriptRendered']);
    let scriptCode = page.getIn(['metadata', 'script']) || '';
    scriptCode = `var datasets = window.store.getState().page.datasets.toJS();
    ${scriptCode}`;
    const parsedPageError = parseSSRError(error);
    return /*#__PURE__*/(
      _jsx("div", { className: "row" }, void 0,
      !parsedPageError && /*#__PURE__*/
      React.createElement(React.Fragment, null,
      setBrowserTitle && /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, page.get('title') ? page.get('title') : 'Page')
      ), /*#__PURE__*/

      _jsx("main", { className: "page-viewer document-viewer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "main-wrapper" }, void 0,
      this.state.customPageError && this.renderErrorWarning(), /*#__PURE__*/
      _jsx(Context.Provider, { value: datasets }, void 0, /*#__PURE__*/
      _jsx(ErrorBoundary, {}, void 0, /*#__PURE__*/
      _jsx(MarkdownViewer, { html: true, markdown: originalText, lists: lists })
      )
      ), /*#__PURE__*/
      _jsx(Footer, {})
      )
      ), /*#__PURE__*/
      _jsx(Script, { scriptRendered: scriptRendered, onError: (e) => this.warningPageError(e) }, void 0,
      scriptCode
      )
      ),

      parsedPageError && /*#__PURE__*/
      _jsx("div", { className: "main-wrapper" }, void 0, /*#__PURE__*/
      _jsx(ErrorFallback, { error: parsedPageError }), /*#__PURE__*/
      _jsx(Footer, {})
      )

      ));

  }
}

PageViewer.defaultProps = {
  page: Immutable.fromJS({}),
  itemLists: Immutable.fromJS([]),
  datasets: Immutable.fromJS({}),
  error: Immutable.fromJS({}),
  setBrowserTitle: true
};









const mapStateToProps = ({ page }) => ({
  page: page.pageView,
  datasets: page.datasets,
  itemLists: page.itemLists,
  error: page.error
});

const container = connect(mapStateToProps)(PageViewer);

export { container as PageViewer };